// extracted by mini-css-extract-plugin
export default {"playButtonWrapper":"playButton-module__playButtonWrapper___G_wDs","playButton":"playButton-module__playButton____cQIC"};